export default "__VITE_ASSET__c82a0472__"